import React from "react";
import InvoiceTable from "../../../component/InvoiceTable";

const TablePurchaseOrder = ({ tableData, formData }) => {
  const { item = [], totalColor = 0 } = tableData;
  const issueQuantity = parseFloat(formData.issueQuantity) || 0;

const transformedData = item.map((itm, index) => {
  const avg = parseFloat(itm.avg) || 0;
  const rate = parseFloat(itm.rate) || 0;
  const colQty = totalColor > 0 ? (issueQuantity / totalColor) * avg : 0;
  const quantity = colQty * totalColor;
  const total = issueQuantity * avg * rate;

  // Update original item object for use in grand total
  item[index].total = total;

  return {
    item: { value: <div className="w-44">{itm.item_name}</div> },
    avg: { value: <div className="w-44">{avg.toFixed(2)}</div> },
    colQty: {
      value: (
        <div className="w-44">
          {`${colQty.toFixed(2)}${totalColor > 0 ? " *" + totalColor : ""}`}
        </div>
      ),
    },
    quantity: { value: <div className="w-44">{quantity.toFixed(2)}</div> },
    unit: { value: <div className="w-24 h-10">{itm.unit}</div> },
    rate: { value: <div className="w-24 h-10">₹{rate.toFixed(2)}</div> },
    total: { value: <div className="w-24 h-10">₹{total.toFixed(2)}</div> },
  };
});


  const columns = [
    "Item *",
    "Avg (1 Pcs) *",
    "1 Col. Qty",
    "Quantity",
    "Unit *",
    "Rate",
    "Total"
  ];

  return (
    <div className="md:px-5 px-2">
      <InvoiceTable
        data={transformedData}
        columns={columns}
        checkbox={false}
        defaultRowSelected={[0]}
      />
    </div>
  );
};

export default TablePurchaseOrder;
